module.exports = __webpack_public_path__ + "static/media/wind-mill.03001631.svg";